import { AbstractSession, AbstractUser } from "@kvix/shared";
import React, { FC } from "react";
import { PremiumVideoPlaceholderPoster } from "./PremiumVideoPlaceholderPoster";

interface Options {
  fallbackToPoster?: boolean;
  rightOffset?: number;
  withBlur?: boolean;
}

interface Props {
  session: AbstractSession;
  user: AbstractUser;
  options?: Options;
  promptTriggered?: boolean;
  setPromptTriggered?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const PremiumVideoPlaceholder: FC<Props> = ({ user, options, session }) => {

  return (
    <PremiumVideoPlaceholderPoster
      user={user}
      session={session}
      fallbackToPoster={options?.fallbackToPoster}
      rightOffset={options?.rightOffset}
      withBlur={options?.withBlur}
    />
  );
};
